import { useFeature } from "./use-feature";

/**
 * Combines two feature flag (LIGHT_AVAILABLE_ITEMS_ENABLED and LIGHT_AVAILABLE_ITEMS_WHITELIST) to determine
 * whether the "light" version of the available-items API is being used.
 *
 * The "light" version is used when the feature flag LIGHT_AVAILABLE_ITEMS_ENABLED is true,
 * or when the feature flag LIGHT_AVAILABLE_ITEMS_WHITELIST contains the itemUuid.
 *
 * This is mainly used to determine whether we should use the regular classifiers or the workspace classifiers.
 *
 * @param {*} itemUuid UUID of the currently selected item
 * @returns {boolean}
 */
export function useLightAvailableItems(itemUuid) {
    const isLightAvailableItemsEnabled = useFeature("LIGHT_AVAILABLE_ITEMS_ENABLED");
    const lightAvailableItemsWhitelist = useFeature("LIGHT_AVAILABLE_ITEMS_WHITELIST");

    if (!itemUuid) {
        return false;
    }

    return (
        isLightAvailableItemsEnabled ||
        (lightAvailableItemsWhitelist && lightAvailableItemsWhitelist.includes(itemUuid))
    );
}
